import { render, staticRenderFns } from "./LunchListRow.vue?vue&type=template&id=68bdb69c&"
import script from "./LunchListRow.vue?vue&type=script&lang=js&"
export * from "./LunchListRow.vue?vue&type=script&lang=js&"
import style0 from "./LunchListRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports